// @ts-nocheck
import React from 'react';
import { pddTicketApi } from './../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';
export default ({
  filter = {},
  onFetched = () => {},
  ...selectProps
}) => <AutocompleteSelect fetch={async params => {
  const data = await pddTicketApi.fetch({
    ...filter,
    ...params
  });
  await onFetched(data.data);
  return data;
}} refetchParams={{
  filter
}} fetchSingle={pddTicketApi.get} notFoundText="Билеты ПДД не найдены" placeholder="Выберите билет из списка" renderOption={(pddTicket, Option) => <Option key={pddTicket.id} value={pddTicket.id} ticket={pddTicket}>
        {pddTicket.idNumber}
      </Option>} {...selectProps} />;
